import { useEffect, useRef, useState } from 'react'

import { Box, GreyGrey60, Spinner } from '@sequencehq/core-components'
import { SECONDS } from '@sequencehq/utils/dates'

const MIN_SPINNER_DURATION = 1 * SECONDS

export const PollingSpinner = ({
  isPolling,
  'data-testid': dataTestId
}: {
  isPolling: boolean
  'data-testid'?: string
}) => {
  const [mounted, setMounted] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const hideTimerRef = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    if (isPolling) {
      clearTimeout(hideTimerRef.current)
      setMounted(true)
      setShowSpinner(true)
    } else if (mounted) {
      hideTimerRef.current = setTimeout(() => {
        setShowSpinner(false)
      }, MIN_SPINNER_DURATION)
    }

    return () => clearTimeout(hideTimerRef.current)
  }, [isPolling, mounted])

  if (!mounted) {
    return null
  }

  return (
    <Box
      data-testid={dataTestId}
      opacity={showSpinner ? 1 : 0}
      transition="opacity 250ms"
      onTransitionEnd={() => {
        if (!showSpinner) {
          setMounted(false)
        }
      }}
    >
      <Spinner size="xs" width="16px" height="16px" color={GreyGrey60} />
    </Box>
  )
}
